import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Select from 'ui/Select';
import { translate } from 'utils/index';
import { messages } from './messages';
import './index.scss';

const ProbabilitySelect = ({ disabled, loading, onChange, options, value }) => {
  return (
    <Select
      className={classNames('probability-select', `probability-select--${value}`)}
      dropdownClassName="probability-select__probability-dropdown"
      disabled={disabled}
      innerLabel={translate(messages.probability)}
      options={options}
      labelKey="key"
      value={value || undefined}
      placeholder={translate(messages.choose)}
      onChange={onChange}
      loading={loading}
      showSearch={false}
    />
  );
};

ProbabilitySelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.number,
};

export default ProbabilitySelect;
